var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_layout"},[_c('div',{staticClass:"layout_center"},[_c('div',{staticClass:"center_back"}),_c('a-card',{staticClass:"center_card"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }